





























import tools from "@/tools.coffee"
import settings from "@/settings"

export default {
    "name": "StateClassified"
    "props": {
        "context": {
            "type": Object
            "required": true
        }
        "review": {
            "type": Object,
            "required": true
        }
        "human_created_on": String

    }
    # "computed":
        # "content": ()->
            # if @context.data?
                # @context.data = JSON.parse(@context.data)
            # return @context
    "data": ()->
        self = this
        return {
            "content": {"uid": "0"},
            "success_img_path": require("@/assets/success_"+String(self.context.uid[0])+".gif")
        }
    "methods":
        "get_scapped_answerlink": (scarppedanswer_uid)->
            return settings.backendUrl+
            '/admin/review/scarppedanswer/'+
            scarppedanswer_uid+'/'
        "getTextFromReview": (review, fr)->
            ret = ""
            for r in review.state_set
                if r.class_name == "AnswerAccepted"
                    if fr
                        ret = r.data.answer.text_fr
                    else
                        ret = r.data.answer.text_native
            return ret
        "random_number": ()->
            return String(Math.floor(Math.random() * 10))
        "copy": (text)->
            textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            this.$store.dispatch("notify",{
                level: "success",
                text: "Copié!",
                seconds: 2
            })        
        "delete_state": ()->
            @$emit("state:delete_state")        
    "created": ()->
        @content = tools.deep_copy(@context)
}
